import { useFindActiveArrayFiltersForFacetName } from '@/features/shop/services/Search/hooks'
import { useFiltersContext } from '@/features/shop/components/ProductFilter/FiltersContext'
import { FilterPillContent } from '@/features/shop/components/ProductFilter/FilterOptions/FilterPillContent'
import { DISPLAY_FORMAT } from '@/features/shared/constants/analytics'
import { FilterScrollWrapper } from '@/features/shop/components/ProductFilter/FilterScrollWrapper'
import { useTrackFilterUtilityClicked } from '@/features/shared/analytics/filters'
import { type GeneralFacetItem } from '@/features/shop/services/Search/types'
import { SEARCH_FILTER_TYPE } from '@/features/shared/constants/global'
import { PillFilterSection } from '@/features/shop/components/ProductFilter/PillFilterSection'

type Props = {
  name: string
  index: number
  items: GeneralFacetItem[]
}

export const FlavorFilterOption = ({ name, index, items }: Props) => {
  const trackFilterUtilityClicked = useTrackFilterUtilityClicked()
  const { facets } = useFiltersContext()
  const findActiveFiltersForFlavors = useFindActiveArrayFiltersForFacetName()
  const activeFilters = findActiveFiltersForFlavors(facets, SEARCH_FILTER_TYPE.FLAVOR)
  const pillName = activeFilters[0] || name

  const handleOnClickFilter = () => {
    trackFilterUtilityClicked({
      list_index: index,
      utility_type: 'dropdown',
      filter_value: SEARCH_FILTER_TYPE.FLAVOR,
      filter_active: Boolean(activeFilters.length),
      display_format: DISPLAY_FORMAT.HORIZONTAL,
    })
  }

  return (
    <FilterScrollWrapper facet={SEARCH_FILTER_TYPE.FLAVOR} index={index} isDropdown>
      <FilterPillContent
        name={pillName}
        filterType={SEARCH_FILTER_TYPE.FLAVOR}
        onClick={handleOnClickFilter}
      >
        <PillFilterSection hideSearchInput items={items} name={SEARCH_FILTER_TYPE.FLAVOR} />
      </FilterPillContent>
    </FilterScrollWrapper>
  )
}
